/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
'use es6';

import { fromJS, Map as ImmutableMap } from 'immutable';
import { useCallback, useState } from 'react';
import SafeStorage from 'SafeStorage';
import UsageTracker from '../utils/UsageTracker';
const STORAGE_KEY = 'academy:requestedlanguages';

const getRequestedLanguagesFromStorage = () => {
  const fromStorage = SafeStorage.getItem(STORAGE_KEY);
  return fromJS(JSON.parse(fromStorage)) || ImmutableMap();
};

const getStoragePath = ({
  trackId,
  lessonId,
  language
}) => [trackId ? 'track' : 'lesson', (trackId || lessonId).toString(), language];

const useLanguageRequested = ({
  trackId,
  lessonId,
  language
}) => {
  const isRequestedFromStorage = getRequestedLanguagesFromStorage().getIn(getStoragePath({
    trackId,
    lessonId,
    language
  }), false);
  const [isRequested, setIsRequested] = useState(isRequestedFromStorage);
  const setLanguageRequested = useCallback(() => {
    SafeStorage.setItem(STORAGE_KEY, JSON.stringify(getRequestedLanguagesFromStorage().setIn(getStoragePath({
      trackId,
      lessonId,
      language
    }), true)));
    UsageTracker.track('interaction', {
      action: 'language-request',
      trackId,
      lessonId,
      requestedLanguage: language
    });
    setIsRequested(true);
  }, [trackId, lessonId, language]);
  return [isRequested, setLanguageRequested];
};

export default useLanguageRequested;